import { api, resolveWalletApi } from "@/api/client";

export const MIN_IRR_DEPOSIT = 1_000_000;

export type IrrCtocSession = {
  ok?: boolean;
  intentId: string;
  status?: string;
  invoiceKey?: string | null;
  cardNumber?: string | null;
  holderDisplay?: string | null;
  amountIrr?: number;
  amountToman?: number;
  expiresAt?: string | null;
  paid?: boolean;
  balanceIrr?: number | null;
  mode?: string;
};

export type IrrCtocPoll = {
  ok?: boolean;
  paid: boolean;
  credited?: boolean;
  giftPaid?: boolean;
  intentId?: string;
  message?: string;
  balanceIrr?: number;
  status?: string;
};

export type IrrCtocReceipt = {
  ok?: boolean;
  paid: boolean;
  verdict?: string;
  reason?: string;
  detectedAmountRial?: number;
  expectedAmountRial?: number;
  message?: string;
  balanceIrr?: number;
  status?: string;
};

export async function startIrrCtoc(token: string, amountIrr: number): Promise<IrrCtocSession> {
  return api<IrrCtocSession>(
    "/irr/deposit/ctoc/start",
    { method: "POST", body: JSON.stringify({ amountIrr }) },
    token
  );
}

export async function getIrrCtoc(token: string, intentId: string): Promise<IrrCtocSession> {
  return api<IrrCtocSession>(`/irr/deposit/ctoc/${encodeURIComponent(intentId)}`, {}, token);
}

export async function pollIrrCtoc(token: string, intentId: string): Promise<IrrCtocPoll> {
  return api<IrrCtocPoll>(
    `/irr/deposit/ctoc/${encodeURIComponent(intentId)}/poll`,
    { method: "POST", body: "{}" },
    token
  );
}

export async function uploadIrrCtocReceipt(
  token: string,
  intentId: string,
  file: File
): Promise<IrrCtocReceipt> {
  const base = resolveWalletApi();
  const form = new FormData();
  form.append("receipt", file);
  const res = await fetch(`${base}/irr/deposit/ctoc/${encodeURIComponent(intentId)}/receipt`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "X-Session-Token": token,
    },
    body: form,
  });
  const text = await res.text();
  let data: unknown = null;
  if (text) {
    try {
      data = JSON.parse(text);
    } catch {
      data = { raw: text };
    }
  }
  if (!res.ok) {
    const detail =
      data && typeof data === "object" && data !== null && "detail" in data
        ? (data as { detail: unknown }).detail
        : data;
    let message = `HTTP_${res.status}`;
    if (typeof detail === "string") message = detail;
    else if (detail && typeof detail === "object" && "code" in (detail as object)) {
      message = String((detail as { code: unknown }).code);
    }
    const err = new Error(message) as Error & { status?: number; code?: string };
    err.status = res.status;
    err.code = message;
    throw err;
  }
  return data as IrrCtocReceipt;
}
